import React from 'react';
import { SvgIconProps } from '@mui/material';
import kangarooSvgUrl from './kangaroo.svg';

/**
 * Ícone Kangaroo - SVG para o gateway WhatsApp Kangaroo.
 * Usa <img> com URL do SVG para evitar erro em produção (vite-plugin-svgr
 * pode retornar URL em vez de componente no build).
 */
const KangarooIcon: React.FC<SvgIconProps> = (props) => {
  const { sx, ...rest } = props;
  const sxObj = typeof sx === 'object' && sx && !Array.isArray(sx) ? sx : {};
  const width = (sxObj as Record<string, unknown>)?.width;
  const height = (sxObj as Record<string, unknown>)?.height;
  const size = (typeof width === 'number' ? width : typeof height === 'number' ? height : 24) as number;
  return (
    <img
      src={kangarooSvgUrl}
      alt="Kangaroo"
      width={size}
      height={size}
      style={{
        width: size,
        height: size,
        display: 'block',
        backgroundColor: 'transparent',
        ...(typeof rest.style === 'object' ? rest.style : {}),
      }}
    />
  );
};

export default KangarooIcon;
